
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 22 23","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.125 16.641h13.75c.76 0 1.375-.615 1.375-1.375V5.641c0-.76-.616-1.375-1.375-1.375H4.125c-.76 0-1.375.616-1.375 1.375v9.625c0 .76.616 1.375 1.375 1.375zM13.75 19.391h-5.5","stroke":"#fff","stroke-width":"1.2","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M13.75 10.454l-4.125-2.75v5.5l4.125-2.75z","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    